export default __webpack_public_path__ + "static/succession-46f219862a361bd2f5462fabdebdbd9b.png";